if (!customElements.get("collection-filter")) {
  class CollectionFilter extends HTMLElement {
    constructor() {
      super();
      this.filters = this.querySelectorAll("[data-filter]");
      this.cards = this.querySelectorAll("[data-card]");
      this.dropdown = this.querySelector("[data-dropdown]");
      this.filteredValues = {};

      this.initFilters();
      this.applyFiltersFromURL(); // Apply filters from URL on page load
    }

    // Initialize filter event listeners
    initFilters() {
      this.filters.forEach((filter) => {
        filter.addEventListener("change", () =>
          this.handleFilterChange(filter),
        );
      });
    }

    // Handle filter change logic
    handleFilterChange(filter) {
      if (filter.hasAttribute("data-all") && filter.checked) {
        this.showAllProducts();
        Array.from(this.filters)
          .filter((filter) => !filter.hasAttribute("data-all"))
          .forEach((filter) => (filter.checked = false));
        this.clearURL(); // Clear the URL when "data-all" is selected
      } else {
        Array.from(this.filters)
          .filter((filter) => filter.hasAttribute("data-all"))
          .forEach((filter) => (filter.checked = false));
        this.updateFilteredValues();
        this.filteredValues.length === 0
          ? this.showAllProducts()
          : this.filterProducts();
        this.updateURL(); // Update the URL with the current filters
      }
    }

    // Show all products
    showAllProducts() {
      this.cards.forEach((product) => product.setAttribute("data-show", true));
    }

    // Update filtered values based on checked filters
    updateFilteredValues() {
      const filteredValues = {};
      this.filteredValues = Array.from(this.filters)
        .filter((filter) => filter.checked)
        .forEach((filter) => {
          const currentList = filteredValues[filter.dataset.filter] || [];
          currentList.push(filter.value);
          filteredValues[filter.dataset.filter] = currentList;
        });

      this.filteredValues = filteredValues;
    }

    // Filter products based on selected filters
    filterProducts() {
      let totalFilterLength = 0;
      if ("area" in this.filteredValues) {
        totalFilterLength = this.filteredValues["area"].length || 0;
      }


      this.cards.forEach((product) => {
        const productTags = product.dataset.tags.split(",");

        // Check if this is a colored card
        if (product.hasAttribute("data-colored")) {
          // Count how many of the special filters are selected
          const specialFilters = ["Health", "Hair", "Skin"];
          const hasRequiredFilters = specialFilters.some((value) =>
            productTags.includes(value),
          );
          const isShown = totalFilterLength >= 2 && hasRequiredFilters;
          product.toggleAttribute("data-show", isShown);
        } else {
          // Regular filtering logic for non-colored cards
          let isShown = true;


          Object.keys(this.filteredValues).forEach((filteredValueKey) => {
            const filteredValues = this.filteredValues[filteredValueKey];
            const show = filteredValues.some((filteredValue) => {
              return productTags.map(productTag => productTag.toLowerCase()).includes(filteredValue.toLowerCase());
            });
            console.log("Filteredvals", filteredValues, "Prodtags", productTags);
            if (!show) {
              isShown = false;
            }
          });
          product.toggleAttribute("data-show", isShown);
        }
      });
    }

    // Update the URL with the current filters
    updateURL() {
      let params = new URLSearchParams();
      if (Object.keys(this.filteredValues).length > 0) {
        Object.keys(this.filteredValues).forEach((filterKey) => {
          params.set(filterKey, this.filteredValues[filterKey].join(","));
        });
      }
      window.history.pushState(
        {},
        "",
        `${window.location.pathname}?${params.toString()}`,
      );
    }

    // Clear the URL parameters (return to original page state)
    clearURL() {
      window.history.pushState({}, "", window.location.pathname);
    }

    // Apply filters from URL on page load
    applyFiltersFromURL() {
      const params = new URLSearchParams(window.location.search);

      params.forEach((value, key) => {
        this.filters.forEach((filter) => {
          if (filter.dataset.filter === key) {
            filter.checked = value.split(",").includes(filter.value);
          }
        });
      });

      this.updateFilteredValues();

      if(Object.keys(this.filteredValues).length > 0) {
        this.filterProducts();
      }

    }
  }

  customElements.define("collection-filter", CollectionFilter);
}

if (!customElements.get("custom-dropdown")) {
  class CustomDropdown extends HTMLElement {
    constructor() {
      super();
      this.sorts = this.querySelectorAll("[data-sort]");
      this.select = this.querySelector("[data-select]");

      this.initSorts();
      this.initDropdownToggle();
    }

    // Initialize sort event listeners
    initSorts() {
      this.sorts.forEach((sort) => {
        sort.addEventListener("change", () => this.handleSortChange(sort));
      });
    }

    // Handle sort change logic
    handleSortChange(sort) {
      this.dataset.value = sort.value;
      this.select.innerText = sort.dataset.name;

      const params = new URLSearchParams(document.location.search);
      params.set("sort_by", sort.value);
      //params.set('product_type_filter', this.dataset.parameters);
      document.location.search = params.toString();
    }

    // Initialize dropdown toggle behavior
    initDropdownToggle() {
      this.addEventListener("click", () => this.toggleAttribute("data-open"));

      document.addEventListener("click", (event) => {
        if (this.hasAttribute("data-open") && !this.contains(event.target)) {
          this.removeAttribute("data-open");
        }
      });
    }
  }

  customElements.define("custom-dropdown", CustomDropdown);
}
